<template>
  <BorderFooterTop />
  <section class="world-class" aria-label="Call to action">
    <div class="max-w-4xl mx-auto px-4 py-12">
      <div class="flex flex-col md:flex-row py-4 lg:py-12">
        <div class="w-full md:w-1/2 mb-8 md:mb-0 text-center md:text-left">
          <p class="flex flex-col text-4xl font-bold">
            <span class="footer-action-text">World-Class Training. Build Your Empire with us.</span>
          </p>
        </div>
        <div class="w-full md:w-1/2">
          <div class="footer-ctas">
            <div class="flex flex-col items-center md:items-end gap-4">
              <ButtonLink 
                text="start your free trial"
                url="/free-trial"
                color="black"
              />
              <ButtonLink
                text="View Programs"
                url="/programs"
                color="transparent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <BorderFooterBottom />
</template>

<script>
  import BorderFooterBottom from './BorderFooterBottom.vue'
  import BorderFooterTop from './BorderFooterTop.vue'
  import ButtonLink from '../Common/ButtonLink.vue'

  export default {
    name: "FooterCTAs",
    components: {
      BorderFooterBottom,
      BorderFooterTop,
      ButtonLink
    }
  }
</script>

<style scoped>
  .world-class {
    background-color: var(--empire-yellow);
  }

  .footer-action-text {
    font-style: italic;
  }

  .footer-ctas :deep(a) {
    min-width: 300px;
    display: block;
  }

  .footer-ctas :deep(button) {
    min-width: 100%;
  }

  .border-footer {
    background-color: var(--empire-yellow);
    background-image: url('../../assets/images/borders/footer-wide.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    width: auto;
    height: 31px;
    margin-bottom: -1px;
    margin-top: -1px;
  }

  .border-footer-top {
    transform: scale(-1, -1); 
  }

  .border-footer-btm {
    margin-bottom: -4px;
  }

  @media screen and (max-width: 1024px) {
    .border-footer {
      background-size: auto 100%;
      overflow-x: hidden;
    }
  }
</style>